export const ideaWizardArticle = {
  title: 'Business Idea Generator: Wizard Inputs',
  slug: 'idea-generator-wizard',
  content: `Business Idea Generator: Wizard Inputs

The wizard collects inputs used to tailor ideas.

1) Skills & level
- Add your skills and set proficiency.
- The generator prioritizes ideas aligned with these skills.

2) Time commitment
- Choose how much time you can commit.
- This shapes the operational complexity of suggested ideas.

3) Work environment
- Select preferred work environments (remote, in-person, etc.).
- Ideas reflect the selected environments.

4) Market scope
- Choose local, national, or international reach.
- Scope affects market sizing and competition.
`,
};
